<template>
  <div>
    <div class="dashboard-head-bg"/>
    <div class="dashboard-head-content">
      <DashboardHeader :firstname=firstname :profile-picture-url=profilePictureUrl />
      <div class="dashboard-status">
        <div class="dashboard-status-content">
          <div class="dashboard-status-content-label">
            Dossier refusé
          </div>
          <div class="dashboard-status-content-progress">
            <ve-progress
                :progress="100"
                :size="100"
                color="#CBDB2A"
                emptyThickness="10%"
                line="square"
                thickness="10%"
            >
              <span class="dashboard-status-content-progress-legend">100%</span>
            </ve-progress>
          </div>
        </div>
      </div>
    </div>

    <div class="dashboard-container">
      <div class="dashboard-section dashboard-section--critical">
        <div class="dashboard-section-header">
          <div class="dashboard-section-header-title dashboard-section-header-title--critical"><img src="@/assets/img/raster.png">Important</div>
          <div><img class="dashboard-section-header-underline" src="@/assets/img/underline_critical.png"></div>
        </div>
        <div class="dashboard-section-content">
          <div class="dashboard-section-content-italic">
            Votre dossier est non-éligible :
            <p v-if="comments && comments.trim()" class="dashboard-comments-box">{{ comments }}</p>
          </div>
        </div>
      </div>


    </div>
  </div>
</template>

<script>

import DashboardHeader from '@/components/Dashboard/Header.vue'

export default {
  name: "DashboardQualified",
  components: {
    DashboardHeader,
  },
  props: {
    firstname: String,
    purcentage: Number,
    textDateConvocation: String,
    textCampusConvocation: String,
    comments: String,
    profilePictureUrl: String,
  },
  methods: {
    toFile: function () {
      this.$router.push({name: 'file'});
    }
  }
};
</script>
<style>
.dashboard-comments-box {
  background-color: #f9f9f9;
  border-left: 4px solid #cb2a2a;
  padding: 1rem;
  border-radius: 8px;
  color: #333;
  font-size: 15px;
  white-space: normal;
  word-break: break-word;
  line-height: 1.5;
}

</style>
